module.exports = __webpack_public_path__ + "img/104.0fb009cb.png";